import { Component, HostBinding, Input } from '@angular/core';

@Component({
	selector: 'status-icon',
	templateUrl: './status-icon.component.html',
	styleUrls: ['./status-icon.component.scss'],
})
export class StatusIcon {
	@Input() number: boolean;
	@HostBinding('class.complete') @Input() complete: boolean;
}
